import styled from 'styled-components';

export const Wrapper = styled.div<{ $isReverse?: boolean }>`
	color: $text-title;
	position: relative;
	width: 100%;
	z-index: 2;
	display: flex;
	flex-direction: ${({ $isReverse }) => ($isReverse ? 'row-reverse' : 'row')};
	align-items: center;
	justify-content: space-between;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const Content = styled.div`
	max-width: 665px;
	width: 100%;
`;

export const IntroPic = styled.img`
	max-width: 580px;
	width: 100%;
	height: auto;
	object-fit: contain;
	flex-shrink: 0;

	@media (max-width: 992px) {
		margin-top: 32px;
	}
`;

export const Title = styled.div`
	font-size: 48px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	span {
		color: ${({ theme }) => theme.colors.control.primary};
	}

	@media (max-width: 992px) {
		font-size: 28px;
	}
`;

export const Text = styled.div`
	font-size: 18px;
	line-height: 1.4;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.text.body};

	@media (max-width: 992px) {
		font-size: 16px;
	}
`;

export const Info = styled.div`
	line-height: 1.15;
	margin: 20px 0;
`;
